import { Card, CardContent, Grid, Typography } from '@usehatchapp/material';
import React, { useLayoutEffect } from 'react';
import { useConnect } from 'redux-bundler-hook';
import DefaultTemplate from 'root/components/templates/Default';
import { ORGANIZATION_DETAILS } from 'root/stores/fresh/schema';
import formatPhoneNumber from 'utils/formatPhoneNumber';
import timestampToFormattedDate from 'utils/timestampToFormattedDate';

import { AfterHours } from './components';

const nameOrDash = (val) => val || '--';

const General = () => {
  const {
    currentOrganization,
    doSetFreshOrganizationKey,
    generalPageHasErrors,
  } = useConnect(
    'selectGeneralPageIsLoading',
    'selectCurrentOrganization',
    'selectGeneralPageHasErrors',
    'doSetFreshOrganizationKey',
  );

  const { contactEmail, contactName, contactPhoneNumber, createdAt, id, name } =
    currentOrganization;

  // using layout effect to prevent flash
  // TODO: replace with sockets and fresh state
  useLayoutEffect(() => {
    // when route loads, reset organization details key to trigger re-fetch
    doSetFreshOrganizationKey({
      fresh: false,
      key: ORGANIZATION_DETAILS,
      organizationIDs: [id],
    });
  }, [doSetFreshOrganizationKey, id]);

  return (
    <DefaultTemplate
      style={{ height: '100%' }}
      showErrorState={generalPageHasErrors}
      title="General"
    >
      <Grid container>
        <Card sx={{ width: '100%' }}>
          <CardContent>
            <Typography variant="h5">Account Details</Typography>
            <Grid
              mt={1.5}
              container
              alignItems="center"
              flexWrap="wrap"
              justifyContent="space-evenly"
            >
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Account Name
                </Typography>
                <Typography>{nameOrDash(name)}</Typography>
              </Grid>
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Account ID
                </Typography>
                <Typography>{nameOrDash(id)}</Typography>
              </Grid>
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Created Date
                </Typography>
                <Typography>
                  {nameOrDash(timestampToFormattedDate(createdAt, 'P'))}
                </Typography>
              </Grid>
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Owner Name
                </Typography>
                <Typography>{nameOrDash(contactName)}</Typography>
              </Grid>
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Owner Email
                </Typography>
                <Typography>{nameOrDash(contactEmail)}</Typography>
              </Grid>
              <Grid container flexDirection="column" width="33%">
                <Typography variant="overline" color="secondary.outlined">
                  Owner Phone
                </Typography>
                <Typography>
                  {nameOrDash(formatPhoneNumber(contactPhoneNumber))}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <AfterHours />
        <Typography mt={2} variant="h6">
          Something look off or need some assistance?{' '}
          <a
            data-test-id="b927df4c-7c4a-4808-b440-24087b585aa0"
            href="mailto: support@usehatchapp.com"
            rel="noreferrer"
            target="_blank"
          >
            Contact our Support Team!
          </a>
        </Typography>
      </Grid>
    </DefaultTemplate>
  );
};

export default General;
